var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "raiseHandList"
    }
  }, [_c('div', {
    staticClass: "right-head"
  }, [_vm._v(" " + _vm._s(_vm.$t('conferenceHost.raisedHandQueue')) + " "), _c('span', {
    staticClass: "opacity4"
  }, [_vm._v("(" + _vm._s(_vm.raiseHandList.length) + ")")])]), _c('div', {
    staticClass: "scrollbar tableBox"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.raiseHandList,
      "empty-text": " ",
      "row-class-name": _vm.redClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('conferenceHost.num'),
      "width": "83"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          staticClass: "number",
          class: {
            red: _vm.PrivateInfo.rtilCode == scope.row.rtilCode
          },
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.$index + 1))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('conferenceHost.handQueuePar'),
      "width": "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "title": scope.row.nickName
          }
        }, [_vm._v(_vm._s(scope.row.nickName) + _vm._s(_vm.tagNameInfo[scope.row.rtilCode] ? ` / ${_vm.tagNameInfo[scope.row.rtilCode]}` : ''))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('conferenceHost.handQueueParCoporation'),
      "width": "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "title": scope.row.organization
          }
        }, [_vm._v(_vm._s(scope.row.organization))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('conferenceHost.handQueueParOperation'),
      "width": "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          staticClass: "configIcon pointer",
          class: {
            active: scope.row.visibles
          }
        }, [_c('operate-button', {
          attrs: {
            "btnList": _vm.handOperateList[scope.row.rtilCode],
            "userInfo": _vm.userInfo,
            "singChannel": {
              id: scope.row.rtilCode,
              channel: _vm.userInfo.realPartyCode
            },
            "nickName": scope.row.nickName,
            "organization": scope.row.organization,
            "currentRole": "participant"
          },
          on: {
            "callback": _vm.attendCallback
          }
        })], 1)];
      }
    }])
  })], 1)], 1), _c('div', {
    staticClass: "pageBox"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "size": "14",
      "total": _vm.raiseHandList.length
    },
    on: {
      "current-change": _vm.changeHandList,
      "prev-click": _vm.changeHandList,
      "next-click": _vm.changeHandList
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };